import React, { useEffect, useState } from 'react';
import axios from '../api/axiosInstance'; // customize the path based on your folder structure
import { FaBan, FaTrash } from 'react-icons/fa';

const BlockedProfile = () => {
  const [blockedProfiles, setBlockedProfiles] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch blocked profiles
  useEffect(() => {
    const fetchBlockedProfiles = async () => {
      try {
        const response = await axios.get('/api/blocked-profiles'); // adjust API endpoint
        setBlockedProfiles(response.data);
      } catch (error) {
        console.error('Error fetching blocked profiles:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlockedProfiles();
  }, []);

  return (
    <div className="p-6 bg-white shadow-md rounded-md">
      <h2 className="text-2xl font-semibold mb-4 text-gray-800">Blocked Profiles</h2>

      {loading ? (
        <p className="text-gray-500">Loading...</p>
      ) : blockedProfiles.length === 0 ? (
        <p className="text-gray-500">No blocked profiles found.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-300 text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="py-2 px-4 border">#</th>
                <th className="py-2 px-4 border">Blocker ID</th>
                <th className="py-2 px-4 border">Blocked ID</th>
                <th className="py-2 px-4 border">Created At</th>
                <th className="py-2 px-4 border">Actions</th>
              </tr>
            </thead>
            <tbody>
              {blockedProfiles.map((profile, index) => (
                <tr key={profile.id} className="hover:bg-gray-50">
                  <td className="py-2 px-4 border text-center">{index + 1}</td>
                  <td className="py-2 px-4 border text-center">{profile.blocker_id}</td>
                  <td className="py-2 px-4 border text-center">{profile.blocked_id}</td>
                  <td className="py-2 px-4 border text-center">
                    {new Date(profile.created_at).toLocaleString()}
                  </td>
                  <td className="py-2 px-4 border text-center">
                    <button className="text-red-600 hover:text-red-800 mr-2">
                      <FaBan title="Unblock" />
                    </button>
                    <button className="text-gray-600 hover:text-gray-800">
                      <FaTrash title="Delete" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default BlockedProfile;
